import { api } from './api';

/** Upload a file without the API client's JSON default converting its bytes. */
export async function uploadFile(file: File, context: { entity: string; entityId?: string }): Promise<{ id: string }> {
  const body = new FormData();
  body.append('file', file);
  body.append('entity', context.entity);
  if (context.entityId) body.append('entityId', context.entityId);
  const response = await uploadMultipart('/files', body);
  const id = response.data?.data?.id;
  if (typeof id !== 'string' || !id.trim()) throw new Error('File upload did not return a file ID. Please retry.');
  return { id };
}

/** Existing evidence endpoints keep their own validation and attachment transaction. */
export function uploadMultipart(path: string, body: FormData) {
  return api.post(path, body, { headers: { 'Content-Type': 'multipart/form-data' } });
}
